// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"324":"css/top.11652346","938":"css/app.11652346","949":"css/app-simple.11652346"}[chunkId] + ".css";
};